var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinBlack = function SvgLinkedinBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.401c0-.579.203-1.057.608-1.433.405-.377.933-.565 1.581-.565.637 0 1.153.185 1.546.556.406.382.609.88.609 1.494a1.83 1.83 0 0 1-.591 1.39c-.405.383-.938.574-1.599.574h-.017c-.637 0-1.152-.191-1.546-.574-.394-.382-.591-.863-.591-1.442Zm.226 15.203V20.998h3.857v11.606h-3.857Zm5.994 0h3.857v-6.48c0-.406.047-.719.14-.939a2.52 2.52 0 0 1 .738-.999c.33-.272.744-.408 1.242-.408 1.297 0 1.946.874 1.946 2.623v6.203H33.5V25.95c0-1.715-.405-3.015-1.216-3.901-.811-.886-1.883-1.33-3.214-1.33-1.495 0-2.659.644-3.493 1.93v.034h-.017l.017-.035v-1.65H21.72c.023.37.035 1.523.035 3.457 0 1.935-.012 4.65-.035 8.149Z",
    fill: "#363940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin-black_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15.5 15)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgLinkedinBlack;